module.exports = __webpack_public_path__ + "img/aboutMA.9157a66a.jpg";